

import React, { useState, useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { Quantum } from 'ldrs/react';
import 'ldrs/react/Quantum.css';
import '../assets/css/timeline.css';
import { handleWheel, handleMouseEnter, handleMouseLeave } from '../utils/Scroll';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { data } from "autoprefixer";
import RecentLocation from '../components/RecentLocation'
import DashboardFooter from "../components/DashboardFooter";

const AddAppointment = ({ prefilledAppointment }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const appointmentFromState = location.state?.appointment || null;



  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  const [appointment, setAppointment] = useState({
    title: appointmentFromState?.title || "",
    name: appointmentFromState?.name || "",
    address: appointmentFromState?.address || "",
    description: appointmentFromState?.description || "",
    number: appointmentFromState?.number || "",
    customerId: appointmentFromState?.customerId || "",
    assignTo: appointmentFromState?.assignTo || [],
    startFrom: appointmentFromState?.startFrom || "",
    endAt: appointmentFromState?.endAt || "",
    startTime: appointmentFromState?.startTime || "",
    endTime: appointmentFromState?.endTime || "",
    isMultiple: appointmentFromState?.isMultiple || false,
    location: {
      latitude: appointmentFromState?.location?.latitude || "",
      longitude: appointmentFromState?.location?.longitude || ""
    },
    id: appointmentFromState?.id || ""
  });



  const [employees, setEmployees] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [customerSearch, setCustomerSearch] = useState({
    name: "",
    phone: "",
    address: ""
  });
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [timelineData, setTimelineData] = useState(null);
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [timelineFilter, setTimelineFilter] = useState('all'); // 'all', 'available', 'busy'
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const token = localStorage.getItem("token");

  const roles = JSON.parse(localStorage.getItem("roles")) || [];
  const isSuperAdmin = roles.includes("Super Admin Access");
  const handleSelectLocation = (location) => {
    console.log("selected location", location)
    setAppointment((prev) => ({
      ...prev,
      location: {
        latitude: location.latitude,
        longitude: location.longitude,
      },
    }));
  };


  // Validation functions
  const validateDates = (startFrom, endAt) => {
    if (startFrom && endAt) {
      const startDate = new Date(startFrom);
      const endDate = new Date(endAt);

      // Check if end date is after start date
      if (endDate <= startDate) {
        return "End At date must be after Start From date";
      }
    }
    return null;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handle checkbox specifically
    if (type === 'checkbox') {
      setAppointment((prev) => ({
        ...prev,
        [name]: checked,
        // Clear endAt field when unchecking isMultiple
        ...(name === 'isMultiple' && !checked && {
          endAt: ""
        })
      }));
    } else if (name === 'latitude' || name === 'longitude') {
      // Handle location fields
      setAppointment((prev) => ({
        ...prev,
        location: {
          ...prev.location,
          [name]: value
        }
      }));
    } else {
      setAppointment((prev) => {
        const newAppointment = {
          ...prev,
          [name]: value,
        };

        // Validate dates when they change
        if (name === 'startFrom' || name === 'endAt') {
          const dateError = validateDates(newAppointment.startFrom, newAppointment.endAt);
          setErrors(prevErrors => ({
            ...prevErrors,
            dateValidation: dateError
          }));
        }

        return newAppointment;
      });
    }
  };




  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1️⃣ Validation checks
    if (errors.dateValidation) {
      NotificationManager.error("Please fix the validation errors before submitting");
      return;
    }

    if (!appointment.title || !appointment.name || !appointment.number || !appointment.address) {
      NotificationManager.error("Please fill in all required fields");
      return;
    }

    if (!appointment.assignTo || appointment.assignTo.length === 0) {
      NotificationManager.error("Please select at least one employee");
      return;
    }

    setLoading(true);

    // 2️⃣ Format time helper
    const formatTime = (time) => (!time ? "09:00:00" : time.length === 5 ? time + ":00" : time);

    // 3️⃣ Build payload
    const payload = {
      ...(appointment.id && { id: appointment.id }), // include id if editing
      name: appointment.name,
      title: appointment.title,
      number: appointment.number,
      address: appointment.address,
      description: appointment.description,
      customerId: appointment.customerId,
      startDateRange: appointment.startFrom,
      endDateRange: appointment.isMultiple ? appointment.endAt : appointment.startFrom,
      startTime: formatTime(appointment.startTime),
      endTime: formatTime(appointment.endTime),
      location: {
        latitude: parseFloat(appointment.location.latitude) || 0,
        longitude: parseFloat(appointment.location.longitude) || 0,
      },
      assignedTo: appointment.assignTo,
    };

    console.log("Sending payload:", payload);

    // 4️⃣ Determine method and URL
    const isEdit = Boolean(appointment.id);
    const url = `${process.env.REACT_APP_HOST_API_URL}/admin-user/create-appointment-range/`;
    const method = isEdit ? "PUT" : "POST";

    try {
      // 5️⃣ Send API request
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      // 6️⃣ Handle non-JSON errors safely
      if (!response.ok) {
        const text = await response.text();
        let errorMsg = text;
        try {
          const json = JSON.parse(text);
          errorMsg = json.message || errorMsg;
        } catch { }
        throw new Error(errorMsg || (isEdit ? "Failed to update appointment" : "Failed to create appointment"));
      }

      // 7️⃣ Parse JSON response
      const data = await response.json();
      console.log("Appointment result:", data);

      // 8️⃣ Show success message
      NotificationManager.success(isEdit ? "Appointment updated successfully!" : "Appointment created successfully!");

      // 9️⃣ Update form or navigate
      if (isEdit) {
        navigate("/dashboard");
      } else {
        setAppointment({
          title: data.title || "",
          name: data.name || "",
          address: data.address || "",
          description: data.description || "",
          number: data.number || "",
          customerId: data.customerId || "",
          assignTo: data.assignTo || [],
          startFrom: data.startFrom || "",
          endAt: data.endAt || "",
          startTime: data.startTime || "",
          endTime: data.endTime || "",
          isMultiple: false,
          location: { latitude: data.location?.latitude || "", longitude: data.location?.longitude || "" },
          id: data.id || "",
        });
      }
    } catch (error) {
      console.error("Error in appointment submission:", error);
      NotificationManager.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };



  // --- DELETE FUNCTION ---
  const handleDelete = async () => {


    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_HOST_API_URL}/app/permanent-delete-appointment/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete appointment");
      }

      NotificationManager.success("Appointment deleted successfully!");
      setShowDeleteModal(false);
      navigate('/dashboard');
    } catch (error) {
      console.error("Error deleting appointment:", error);
      NotificationManager.error(error.message || "Failed to delete appointment");
    } finally {
      setLoading(false);
    }
  };



  // Fetch employees from API
  const fetchEmployees = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_HOST_API_URL}/app/employes-list/`, {
        method: 'POST',
        headers: {
          Authorization: "Bearer " + token,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });

      if (!res.ok) throw new Error("Failed to fetch employees");

      const data = await res.json();
      console.log("Fetched employees:", data);
      setEmployees(data);
    } catch (err) {
      console.error(err);
      NotificationManager.error("Error fetching employees");
    }
  };

  // Fetch employee timeline data
  const fetchEmployeeTimeline = async (date, startTime, endTime) => {
    if (!date || !startTime || !endTime) {
      return;
    }

    try {
      setTimelineLoading(true);

      // Format time to include seconds if not present
      const formatTime = (time) => {
        if (!time) return '09:00:00';
        if (time.length === 5) {
          return time + ':00';
        }
        return time;
      };

      const payload = {
        date: date,
        startTime: formatTime(startTime),
        endTime: formatTime(endTime)
      };

      const response = await fetch(`${process.env.REACT_APP_HOST_API_URL}/admin-user/employee-timeline/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Failed to fetch employee timeline');
      }

      const data = await response.json();
      setTimelineData(data);
    } catch (error) {
      console.error('Error fetching employee timeline:', error);
      NotificationManager.error('Failed to fetch employee timeline');
    } finally {
      setTimelineLoading(false);
    }
  };

  // Fetch customers from API
  const fetchCustomers = async () => {
    try {
      setLoading(true);
      let url = `${process.env.REACT_APP_HOST_API_URL}/admin-user/customers/?`;
      const params = new URLSearchParams();

      Object.entries(customerSearch).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });

      url += params.toString();

      const res = await fetch(url, {
        headers: { Authorization: "Bearer " + token },
      });

      if (!res.ok) throw new Error("Failed to fetch customers");

      const data = await res.json();
      setCustomers(data);
    } catch (err) {
      console.error(err);
      NotificationManager.error("Error fetching customers");
    } finally {
      setLoading(false);
    }
  };

  // Handle customer search input change
  const handleCustomerSearchChange = (e) => {
    const { name, value } = e.target;
    setCustomerSearch((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle customer selection
  const handleCustomerSelect = (customer) => {
    setAppointment((prev) => ({
      ...prev,
      name: customer.name,
      number: customer.phone,
      address: customer.address,
      customerId: customer.id
    }));
    setShowCustomerModal(false);
    NotificationManager.success("Customer selected successfully");
  };

  // Handle employee selection (multiple)
  const handleEmployeeSelect = (employeeUsername) => {
    setAppointment((prev) => {
      const currentAssignTo = prev.assignTo || [];
      const isSelected = currentAssignTo.includes(employeeUsername);

      if (isSelected) {
        // Remove employee if already selected
        return {
          ...prev,
          assignTo: currentAssignTo.filter(username => username !== employeeUsername)
        };
      } else {
        // Add employee if not selected
        return {
          ...prev,
          assignTo: [...currentAssignTo, employeeUsername]
        };
      }
    });
  };

  // Open customer modal and fetch customers
  const handleShowCustomers = () => {
    setShowCustomerModal(true);
    fetchCustomers();
  };

  // Open employee modal
  // const handleShowEmployees = () => {
  //   setShowEmployeeModal(true);
  // };
  const handleShowEmployees = () => {
    if (!appointment.startFrom || !appointment.startTime || !appointment.endTime) {
      NotificationManager.warning("Please set the date, start time, and end time first");
      return;
    }
    if (!timelineData) {
      NotificationManager.warning("Please refresh the employee timeline before assigning");
      return;
    }
    setShowEmployeeModal(true);
  };
  // Handle employee search input change
  const handleEmployeeSearchChange = (e) => {
    setEmployeeSearch(e.target.value);
  };
  const timeToHours = (timeStr) => {
    if (!timeStr) return null;
    const [h, m = 0, s = 0] = timeStr.split(':').map(Number);
    return h + m / 60 + s / 3600;
  };

  const freeUsernamesForSlot = (() => {
    if (!timelineData?.employees || !appointment.startTime || !appointment.endTime) {
      return null;
    }

    const normalize = (t) => (t.length === 5 ? t + ':00' : t);
    const reqStart = timeToHours(normalize(appointment.startTime));
    const reqEnd = timeToHours(normalize(appointment.endTime));

    if (reqStart === null || reqEnd === null || reqEnd <= reqStart) return null;

    const usernames = new Set();

    timelineData.employees.forEach((emp) => {
      const isFreeForSlot = (emp.free_slots || []).some((slot) => {
        const slotStart = timeToHours(slot.start_time);
        const slotEnd = timeToHours(slot.end_time);
        return slotStart <= reqStart && slotEnd >= reqEnd;
      });

      if (isFreeForSlot) usernames.add(emp.employee_username);
    });

    return usernames;
  })();

  const timelineByUsername = (() => {
    const map = {};
    (timelineData?.employees || []).forEach((emp) => {
      map[emp.employee_username] = emp;
    });
    return map;
  })();

  // Filter employees based on search
  // const filteredEmployees = employees.filter(employee =>
  //   employee.full_name.toLowerCase().includes(employeeSearch.toLowerCase())
  // );

  const filteredEmployees = employees.filter((employee) => {
    const matchesSearch = employee.full_name
      .toLowerCase()
      .includes(employeeSearch.toLowerCase());

    // If no timeline has been fetched yet, freeUsernamesForSlot is null — show everyone
    // until the user actually picks a slot and hits "Refresh Employee Timeline".
    if (isSuperAdmin) return matchesSearch;
    const isFree =
      freeUsernamesForSlot === null || freeUsernamesForSlot.has(employee.username);

    return matchesSearch && isFree;
  });

  // Handle timeline data filtering
  const getFilteredTimelineEmployees = () => {
    if (!timelineData || !timelineData.employees) return [];

    switch (timelineFilter) {
      case 'available':
        return timelineData.employees.filter(emp => emp.is_available);
      case 'busy':
        return timelineData.employees.filter(emp => !emp.is_available);
      default:
        return timelineData.employees;
    }
  };

  // Handle time field blur events
  const handleTimeBlur = () => {
    if (appointment.startFrom && appointment.startTime && appointment.endTime) {
      fetchEmployeeTimeline(appointment.startFrom, appointment.startTime, appointment.endTime);
    }
  };

  // Fetch employees on component mount
  useEffect(() => {
    fetchEmployees();
  }, []);




  return (
    <div className="d-flex flex-column min-vh-100 pb-2 px-3">
      {/* Main content area (scrolls normally) */}
      <div className="flex-grow-1">
        <div className="container-fluid pb-2 px-2 px-md-4" style={{ paddingTop: '20px' }}>
          <style>
            {`
          .customer-list::-webkit-scrollbar {
            display: none;
          }
            
        `}
          </style>

          {/* Page Heading */}
          <div className="row mb-4 bg-white shadow-sm border-bottom sticky-top py-3 px-md-3 px-2 rounded"
            style={{

              zIndex: 1050,
              background: "linear-gradient(135deg, #0564bf, #89CFF0"
            }}>
            <div className="col-12"
            >
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                <div>
                  <h3 className=" text-light mb-1">
                    Add New Appointment
                  </h3>
                  <p className="text-light mb-0">
                    Create and schedule a new appointment with customer and employee details
                  </p>
                </div>

              </div>
            </div>
          </div>

          <div className="row">
            {/* Appointment Form */}
            <div className="col-12 col-lg-8 "
            //  style={{ paddingRight: '50px', paddingLeft: '50px' }}
            >
              <div className="border rounded p-3 bg-white shadow-sm">
                <h4 className="text-center mb-4" style={{ color: "#0564bf" }}>
                  Add Appointment
                </h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        name="title"
                        value={appointment.title}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label">Customer Name</label>
                      <div className="input-group">
                        <input
                          type="text"
                          name="name"
                          value={appointment.name}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={handleShowCustomers}
                        >
                          Select Customer
                        </button>
                      </div>
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="number"
                        name="number"
                        value={appointment.number}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label">Assign To</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={appointment.assignTo.length > 0 ? `${appointment.assignTo.length} employee(s) selected` : "Click to select employees"}
                          readOnly
                          style={{ cursor: 'pointer' }}
                          onClick={handleShowEmployees}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={handleShowEmployees}
                        >
                          Select Employees
                        </button>
                      </div>
                      {appointment.assignTo.length > 0 && (
                        <div className="mt-2">
                          <small className="text-muted">
                            Selected: {appointment.assignTo.length} employee(s)
                          </small>
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Start From</label>
                      <input
                        type="date"
                        name="startFrom"
                        value={appointment.startFrom}
                        onChange={handleChange}
                        className={`form-control ${errors.dateValidation ? 'is-invalid' : ''}`}
                        required
                      />
                      {errors.dateValidation && (
                        <div className="invalid-feedback">
                          {errors.dateValidation}
                        </div>
                      )}
                    </div>

                    {/* Multiple Appointment Checkbox */}
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="isMultiple"
                          checked={appointment.isMultiple}
                          onChange={handleChange}
                          id="isMultiple"
                        />
                        <label className="form-check-label" htmlFor="isMultiple">
                          <strong>Is Multiple?</strong> (Check if this is a recurring appointment)
                        </label>
                      </div>
                    </div>

                    {/* End At Field - Only show when isMultiple is checked */}
                    {appointment.isMultiple && (
                      <div className="col-12 col-md-6">
                        <label className="form-label">End At</label>
                        <input
                          type="date"
                          name="endAt"
                          value={appointment.endAt}
                          onChange={handleChange}
                          className={`form-control ${errors.dateValidation ? 'is-invalid' : ''}`}
                          required={appointment.isMultiple}
                        />
                        {errors.dateValidation && (
                          <div className="invalid-feedback">
                            {errors.dateValidation}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="col-12">
                      <label className="form-label">Address</label>
                      <textarea
                        name="address"
                        value={appointment.address}
                        onChange={handleChange}
                        className="form-control"
                        rows={2}
                      />
                    </div>

                    {/* Location Fields */}
                    <div className="col-12 col-md-6">
                      <label className="form-label">Latitude</label>
                      <input
                        type="number"
                        step="any"
                        name="latitude"
                        value={appointment.location.latitude}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="e.g., 1.3521"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label">Longitude</label>
                      <input
                        type="number"
                        step="any"
                        name="longitude"
                        value={appointment.location.longitude}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="e.g., 103.8198"
                      />
                    </div>

                    {/* Time Fields */}
                    <div className="col-12 col-md-6">
                      <label className="form-label">Start Time</label>
                      <input
                        type="time"
                        name="startTime"
                        value={appointment.startTime}
                        onChange={handleChange}
                        onBlur={handleTimeBlur}
                        className="form-control"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label">End Time</label>
                      <input
                        type="time"
                        name="endTime"
                        value={appointment.endTime}
                        onChange={handleChange}
                        onBlur={handleTimeBlur}
                        className="form-control"
                      />
                    </div>

                    {/* Timeline Check Button */}
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={() => {
                          if (appointment.startFrom && appointment.startTime && appointment.endTime) {
                            fetchEmployeeTimeline(appointment.startFrom, appointment.startTime, appointment.endTime);
                          } else {
                            NotificationManager.warning("Please fill in date, start time, and end time first");
                          }
                        }}
                        disabled={!appointment.startFrom || !appointment.startTime || !appointment.endTime}
                      >
                        <i className="fas fa-clock me-2"></i>
                        Refresh Employee Timeline
                      </button>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        value={appointment.description}
                        onChange={handleChange}
                        className="form-control"
                        rows={2}
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-center gap-3 mt-4">
                    <button
                      type="submit"
                      className="btn btn-outline-primary px-4"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Quantum size="20" speed="1.75" color="#0564bf" />
                          <span className="ms-2">{appointment.id ? "Updating Appointment..." : "Creating Appointment..."}</span>
                        </>
                      ) : (
                        appointment.id ? "Update Appointment" : "Save Appointment"
                      )}
                    </button>

                    {appointment.id && (
                      <button
                        type="button"
                        className="btn btn-outline-danger px-4"
                        onClick={() => setShowDeleteModal(true)}
                        disabled={loading}
                      >
                        Delete Appointment
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>

            {/* Employee Timeline Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="border rounded p-3 bg-white shadow-sm"
              //  style={{ minHeight: '100vh' }}
              >
                <h4 className="text-center mb-4" style={{ color: "#0564bf" }}>
                  Employee Timeline
                </h4>

                {!timelineData ? (
                  <div className="text-center py-5">
                    <i className="fas fa-clock fa-3x text-muted mb-3"></i>
                    <p className="text-muted">Enter date and time to view employee timeline</p>
                  </div>
                ) : (
                  <>
                    {/* Timeline Summary */}
                    <div className="card-body border rounded p-2 mb-2">
                      <h6 className="card-title text-center">Summary</h6>
                      <div className="flex justify-content-center text-center">
                        <div className="col-4">
                          <div className="text-primary fw-bold">{timelineData.total_employees}</div>
                          <small className="text-muted">Total</small>
                        </div>
                        <div className="col-4">
                          <div className="text-success fw-bold">{timelineData.available_employees}</div>
                          <small className="text-muted">Available</small>
                        </div>
                        <div className="col-4">
                          <div className="text-warning fw-bold">{timelineData.busy_employees}</div>
                          <small className="text-muted">Busy</small>
                        </div>
                      </div>
                    </div>

                    {/* Filter Options */}
                    <div className="mb-3">
                      <label className="form-label">Filter Employees</label>
                      <div className="btn-group w-100" role="group">
                        <input
                          type="radio"
                          className="btn-check"
                          name="timelineFilter"
                          id="filterAll"
                          checked={timelineFilter === 'all'}
                          onChange={() => setTimelineFilter('all')}
                        />
                        <label className="btn btn-outline-primary" htmlFor="filterAll">
                          All
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="timelineFilter"
                          id="filterAvailable"
                          checked={timelineFilter === 'available'}
                          onChange={() => setTimelineFilter('available')}
                        />
                        <label className="btn btn-outline-success" htmlFor="filterAvailable">
                          Available
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="timelineFilter"
                          id="filterBusy"
                          checked={timelineFilter === 'busy'}
                          onChange={() => setTimelineFilter('busy')}
                        />
                        <label className="btn btn-outline-warning" htmlFor="filterBusy">
                          Busy
                        </label>
                      </div>
                    </div>

                    {/* Employee List */}
                    <div className="employee-timeline-list"
                      style={{ maxHeight: '610px', overflowY: 'auto', }}
                      onWheel={handleWheel}
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      {timelineLoading ? (
                        <div className="text-center py-4">
                          <Quantum size="30" speed="1.75" color="#0564bf" />
                          {/* <p className="mt-2 text-muted">Loading timeline...</p> */}
                        </div>
                      ) : (
                        getFilteredTimelineEmployees().map((employee) => (
                          <div key={employee.employee_id} className="border rounded shadow-sm mb-2 w-100">
                            <div className="card-body py-1 px-3">
                              <div className="d-flex justify-content-between align-items-start mb-1">
                                <div>
                                  <h6 className="mb-0" style={{ fontSize: '0.9rem' }}>{employee.employee_name}</h6>
                                  <small className="text-muted" style={{ fontSize: '0.75rem' }}>@{employee.employee_username}</small>
                                </div>
                                <span className={`badge ${employee.is_available ? 'bg-success' : 'bg-warning'}`} style={{ fontSize: '0.7rem' }}>
                                  {employee.is_available ? 'Available' : 'Busy'}
                                </span>
                              </div>

                              {/* Timeline Progress Bar */}
                              <div className="mb-1">
                                <div className="d-flex justify-content-between mb-1">
                                  <small className="text-muted">Timeline</small>
                                  <small className="text-muted">
                                    {parseFloat(employee.total_free_time_hours).toFixed(1)}h free / {parseFloat(employee.total_assigned_time_hours).toFixed(1)}h assigned
                                  </small>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>


                                  <div
                                    className="progress-bar bg-success"
                                    role="progressbar"
                                    style={{ width: `${(employee.total_free_time_hours / employee.timeline_summary.total_timeline_hours) * 100}%` }}
                                    title="Free Time"
                                  ></div>
                                  <div
                                    className="progress-bar bg-warning"
                                    role="progressbar"
                                    style={{ width: `${(employee.total_assigned_time_hours / employee.timeline_summary.total_timeline_hours) * 100}%` }}
                                    title="Assigned Time"
                                  ></div>
                                  {/* Remaining Time (Red) */}
                                  <div
                                    className="progress-bar bg-success"
                                    role="progressbar"
                                    style={{
                                      width: `${100 - ((employee.total_free_time_hours + employee.total_assigned_time_hours) / employee.timeline_summary.total_timeline_hours) * 100}%`,
                                    }}
                                    title="Remaining Time"
                                  ></div>
                                </div>
                                <div className="timeline-legend">
                                  <div className="legend-item">
                                    <div className="legend-color legend-free"></div>
                                    <span>Free</span>
                                  </div>
                                  <div className="legend-item">
                                    <div className="legend-color legend-assigned"></div>
                                    <span>Assigned</span>
                                  </div>
                                </div>
                              </div>

                              {/* Free Slots */}
                              {/* {employee.free_slots && employee.free_slots.length > 0 && (
                                <div className="mb-1">
                                  <small className="text-success fw-bold" style={{ fontSize: '0.7rem' }}>Free:</small>
                                  {employee.free_slots.map((slot, index) => (
                                    <div key={index} className="small text-muted" style={{ fontSize: '0.65rem' }}>
                                      {slot.start_time}-{slot.end_time} ({parseFloat(slot.duration).toFixed(1)}h)<br />

                                    </div>


                                  ))}

                                </div>
                              )} */}


                              {employee && (
                                <div className="mb-1">
                                  <small className="text-success fw-bold" style={{ fontSize: '0.7rem' }}>Free:</small>

                                  {/* Regular Free Slots */}
                                  {employee.free_slots && employee.free_slots.length > 0 && (
                                    employee.free_slots.map((slot, index) => (
                                      <div key={index} className="small text-muted" style={{ fontSize: '0.65rem' }}>
                                        {slot.start_time} - {slot.end_time} ({parseFloat(slot.duration).toFixed(1)}h)
                                      </div>
                                    ))
                                  )}

                                  {/* If assigned appointment end_time < timeline end_time, show remaining free slot */}
                                  {employee.assigned_appointments &&
                                    employee.assigned_appointments.length > 0 &&
                                    (() => {
                                      const lastAppt = employee.assigned_appointments[employee.assigned_appointments.length - 1];
                                      const endTimeline = employee.timeline_summary?.timeline_end;

                                      if (lastAppt?.end_time !== endTimeline) {

                                        const toHours = (timeStr) => {
                                          const [h, m, s] = timeStr.split(':').map(Number);
                                          return h + m / 60 + (s || 0) / 3600;
                                        };

                                        const startH = toHours(lastAppt.end_time);
                                        const endH = toHours(endTimeline);
                                        const duration = endH - startH;

                                        if (duration > 0) {
                                          return (
                                            <div className="small text-muted" style={{ fontSize: '0.65rem' }}>
                                              {lastAppt.end_time} - {endTimeline} ({duration.toFixed(2)}h)
                                            </div>
                                          );
                                        }
                                      }
                                      return null;
                                    })()}
                                </div>
                              )}


                              {/* Assigned Appointments */}
                              {employee.assigned_appointments && employee.assigned_appointments.length > 0 && (
                                <div>
                                  <small className="text-warning fw-bold" style={{ fontSize: '0.7rem' }}>Assigned:</small>
                                  {employee.assigned_appointments.map((appointment, index) => (
                                    <div key={index} className="small text-muted" style={{ fontSize: '0.65rem' }}>
                                      {appointment.start_time}-{appointment.end_time} ({appointment.client_name})
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* Customer Selection Modal */}
          <div className={`modal fade ${showCustomerModal ? 'show' : ''} `}
            style={{ display: showCustomerModal ? 'block' : 'none' }}
            tabIndex="-1"
            role="dialog"
            onWheel={handleWheel}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div className="modal-dialog modal-lg" role="document" style={{ minHeight: '90vh', maxHeight: '90vh' }}>
              <div className="modal-content" style={{ minHeight: '90vh', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                <div className="modal-header" style={{ flexShrink: 0 }}>
                  <h5 className="modal-title text-primary">Select Customer</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowCustomerModal(false)}
                  ></button>
                </div>
                <div className="modal-body pb-0" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                  {/* Search Filters */}
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label className="form-label">Search by Name</label>
                      <input
                        type="text"
                        name="name"
                        value={customerSearch.name}
                        onChange={handleCustomerSearchChange}
                        className="form-control"
                        placeholder="Enter customer name"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Search by Phone</label>
                      <input
                        type="text"
                        name="phone"
                        value={customerSearch.phone}
                        onChange={handleCustomerSearchChange}
                        className="form-control"
                        placeholder="Enter phone number"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Search by Address</label>
                      <input
                        type="text"
                        name="address"
                        value={customerSearch.address}
                        onChange={handleCustomerSearchChange}
                        className="form-control"
                        placeholder="Enter address"
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mb-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={fetchCustomers}
                      disabled={loading}
                    >
                      {loading ? 'Searching...' : 'Search Customers'}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setCustomerSearch({ name: "", phone: "", address: "" });
                        fetchCustomers();
                      }}
                    >
                      Clear Filters
                    </button>
                  </div>

                  {/* Customer List */}
                  <div className="customer-list" style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    overflowWrap: 'break-word',
                    wordWrap: 'break-word',
                    scrollbarWidth: 'none', /* Firefox */
                    msOverflowStyle: 'none' /* IE and Edge */
                  }}>
                    {loading ? (
                      <div className="text-center py-5">
                        <Quantum
                          size="45"
                          speed="1.75"
                          color="#0564bf"
                        />
                        {/* <p className="mt-3 text-muted">Loading customers...</p> */}
                      </div>
                    ) : customers.length > 0 ? (
                      <div className="d-flex flex-wrap gap-3 justify-content-center" style={{ width: '100%', maxWidth: '100%' }}>
                        {customers.map((customer) => (
                          <div key={customer.id} className="col-md-6  mx-2 col-lg-4">
                            <div className="card customer-card h-100" style={{
                              cursor: 'pointer',
                              marginBottom: '1rem',
                              overflowWrap: 'break-word',
                              wordWrap: 'break-word'
                            }}>
                              <div className="card-body">
                                <div className="d-flex align-items-center mb-2">
                                  <div className="customer-avatar me-3"
                                    style={{
                                      width: '40px',
                                      height: '40px',
                                      borderRadius: '50%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      color: 'white',
                                      fontWeight: 'bold',
                                      background: customer.gender === 'Female' ? '#e91e63' : customer.gender === 'Male' ? '#007bff' : '#6c757d'
                                    }}>
                                    {customer.name.charAt(0).toUpperCase()}
                                  </div>
                                  <div style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>
                                    <h6 className="mb-0" style={{ wordBreak: 'break-word' }}>{customer.name}</h6>
                                    <small className="text-muted">{customer.gender}</small>
                                  </div>
                                </div>
                                <div className="customer-info">
                                  <div className="customer-info-item mb-1" style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>
                                    <i className="fas fa-phone me-2"></i>
                                    <small style={{ wordBreak: 'break-word' }}>{customer.phone}</small>
                                  </div>
                                  <div className="customer-info-item mb-1" style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>
                                    <i className="fas fa-envelope me-2"></i>
                                    <small style={{ wordBreak: 'break-word' }}>{customer.email}</small>
                                  </div>
                                  <div className="customer-info-item" style={{ overflowWrap: 'break-word', wordWrap: 'break-word' }}>
                                    <i className="fas fa-map-marker-alt me-2"></i>
                                    <small style={{ wordBreak: 'break-word' }}>{customer.address}</small>
                                  </div>
                                </div>
                                <button
                                  className="btn btn-primary btn-sm mt-2 w-100"
                                  onClick={() => handleCustomerSelect(customer)}
                                >
                                  Select This Customer
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-muted">No customers found. Try adjusting your search criteria.</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="modal-footer" style={{ flexShrink: 0 }}>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowCustomerModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Employee Selection Modal */}
          <div className={`modal fade ${showEmployeeModal ? 'show' : ''} `}
            style={{ display: showEmployeeModal ? 'block' : 'none' }}
            tabIndex="-1"
            role="dialog"
            onWheel={handleWheel}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div className="modal-dialog modal-lg" role="document" style={{ minHeight: '90vh', maxHeight: '90vh' }}>
              <div className="modal-content" style={{ minHeight: '90vh', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                <div className="modal-header" style={{ flexShrink: 0 }}>
                  <h5 className="modal-title text-primary">Select Employees</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowEmployeeModal(false)}
                  ></button>
                </div>
                <div className="modal-body pb-0" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                  {/* Search Filter */}
                  <div className="mb-3">
                    <label className="form-label">Search by Full Name</label>
                    <input
                      type="text"
                      value={employeeSearch}
                      onChange={handleEmployeeSearchChange}
                      className="form-control"
                      placeholder="Enter employee full name to search"
                    />
                  </div>

                  {/* Employee List */}
                  <div className="employee-list" style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    scrollbarWidth: 'thin',
                    msOverflowStyle: 'scrollbar'
                  }}>
                    {filteredEmployees.length > 0 ? (
                      <div className="row g-2">
                        {filteredEmployees.map((employee) => {
                          const isSelected = appointment.assignTo.includes(employee.username);
                          return (
                            <div key={employee.id} className="col-12">
                              <div
                                className={`form-check employee-item ${isSelected ? 'selected' : ''}`}
                                style={{
                                  padding: '0.75rem',
                                  borderRadius: '0.375rem',
                                  cursor: 'pointer',
                                  backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                                  border: isSelected ? '2px solid #2196f3' : '1px solid #dee2e6',
                                  transition: 'all 0.2s ease',
                                  marginBottom: '0.5rem'
                                }}
                                onClick={() => handleEmployeeSelect(employee.username)}
                              >
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => { }} // Handled by onClick
                                  style={{ pointerEvents: 'none' }}
                                />
                                <label className="form-check-label" style={{ cursor: 'pointer', margin: 0, width: '100%' }}>
                                  {/* <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <strong>{employee.full_name}</strong>
                                      <small className="text-muted d-block">@{employee.username}</small>
                                      {employee.role && (
                                        <small className="text-info d-block">Role: {employee.role}</small>
                                      )}
                                    </div>
                                    {isSelected && (
                                      <span className="badge bg-primary">Selected</span>
                                    )}
                                  </div> */}
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <strong>{employee.full_name}</strong>
                                      <small className="text-muted d-block">@{employee.username}</small>
                                      {employee.role && (
                                        <small className="text-info d-block">Role: {employee.role}</small>
                                      )}
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      {isSuperAdmin && (
                                        <span
                                          className={`badge ${freeUsernamesForSlot && freeUsernamesForSlot.has(employee.username)
                                              ? 'bg-success'
                                              : 'bg-warning'
                                            }`}
                                        >
                                          {freeUsernamesForSlot && freeUsernamesForSlot.has(employee.username)
                                            ? 'Free'
                                            : 'Busy'}
                                        </span>
                                      )}
                                      {isSelected && <span className="badge bg-primary">Selected</span>}
                                    </div>
                                  </div>
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-muted">
                          {employeeSearch ? 'No employees found matching your search.' : 'No employees available.'}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="modal-footer" style={{ flexShrink: 0 }}>
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      <small className="text-muted">
                        {appointment.assignTo.length} employee(s) selected
                      </small>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary me-2"
                        onClick={() => setShowEmployeeModal(false)}
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setShowEmployeeModal(false)}
                      >
                        Confirm Selection
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Delete Confirmation Modal */}
          <div
            className={`modal fade ${showDeleteModal ? 'show' : ''}`}
            style={{ display: showDeleteModal ? 'block' : 'none' }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header border-0 pb-2 mb-2">
                  <h5 className="modal-title d-flex align-items-center">
                    <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  ></button>
                </div>
                <div className="modal-body pt-0">
                  <div className="text-center">
                    <div className="mb-3">
                      <div
                        className="delete-modal-avatar rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                        style={{
                          width: "60px",
                          height: "60px",
                          backgroundColor: "#ff6b6b", // Red for appointment deletion
                          color: "white",
                          fontSize: "24px",
                          fontWeight: "bold"
                        }}
                      >
                        {appointment?.name ? appointment.name.charAt(0).toUpperCase()
                          : <i className="fas fa-calendar-times"></i>}

                      </div>
                      <h6 className="mb-1">{appointment.name || "Appointment"}</h6>
                      <small className="text-muted">
                        {appointment.name ? ` ${appointment.title}` : ""}
                      </small>
                    </div>

                    <div className="alert alert-warning warning-alert border-0">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      <strong>Warning:</strong> This action cannot be undone. Are you sure you want to delete this appointment?
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 pt-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    <i className="fas fa-times me-1"></i> Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDelete}
                    disabled={loading}
                  >
                    <i className="fas fa-trash me-1"></i> Delete Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Modal Backdrop */}
          {showDeleteModal && <div className="modal-backdrop fade show"></div>}
          {/* Modal Backdrop */}
          {(showCustomerModal || showEmployeeModal) && <div className="modal-backdrop fade show"></div>}

          <RecentLocation customer_id={appointment.customerId} onSelectLocation={handleSelectLocation} />
        </div>
      </div>
      <DashboardFooter />
    </div>
  );
};

export default AddAppointment;
